import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarTarjetasAsignadas = ({ refresh }) => {
  const [tarjetas, setTarjetas] = useState([]);

  const getData = useCallback(async () => {
    try {
      const { data } = await axios.get("/api/tarjetas/listall");

      if (!data.ok) throw new Error(data.message);

      const tarjetasConFunciones = data.asignaciones.map((tarjeta) => ({
        ...tarjeta,
        documento: tarjeta.aprendizObjectId?.documentoAprendiz || 'N/A',
        nombre: `${tarjeta.aprendizObjectId?.nombre1Aprendiz || ''} ${tarjeta.aprendizObjectId?.apellido1Aprendiz || ''}`.trim(),
        fechaAsignacion: new Date(tarjeta.fechaAsignacion).toLocaleDateString(),
        estado: tarjeta.estado,
        funciones: (
          <div className="d-flex gap-2">
            <button
              className="btn btn-danger"
              style={{ width: "30px", height: "30px", padding: "0" }}
              onClick={() => desactivarTarjeta(tarjeta._id)}
              title="Desactivar Tarjeta"
            >
              <i className="fa-solid fa-ban"></i>
            </button>
          </div>
        ),
      }));

      setTarjetas(tarjetasConFunciones.reverse());
    } catch (error) {
      console.error("Error al cargar las tarjetas asignadas:", error.message);
      Swal.fire('Error', 'No se pudieron cargar las tarjetas.', 'error');
    }
    // eslint-disable-next-line 
  }, []);

  useEffect(() => {
    getData();
  }, [getData, refresh]);

  const desactivarTarjeta = async (id) => {
    try {
      const confirm = await Swal.fire({
        title: '¿Está seguro?',
        text: 'La tarjeta será desactivada.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, desactivar',
        cancelButtonText: 'Cancelar',
      });

      if (confirm.isConfirmed) {
        await axios.put(`/api/tarjetas/desactivar/${id}`);
        getData();

        Swal.fire({
          icon: 'success',
          title: 'Tarjeta desactivada correctamente',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error('Error al desactivar la tarjeta:', error.message);
      Swal.fire('Error', 'No se pudo desactivar la tarjeta.', 'error');
    }
  };

  const columns = React.useMemo(() => [
    { Header: 'Documento', accessor: 'documento' },
    { Header: 'Nombre Aprendiz', accessor: 'nombre' },
    { Header: 'UID Tarjeta', accessor: 'tarjetaUID' },
    { Header: 'Fecha Asignación', accessor: 'fechaAsignacion' },
    { Header: 'Estado', accessor: 'estado' },
    { accessor: 'funciones' }
  ], []);

  return (
     <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1>Tarjetas Asignadas</h1>
      {Array.isArray(tarjetas) && tarjetas.length > 0 ? (
        <DataTable columns={columns} data={tarjetas} />
      ) : (
        <p>Cargando tarjetas asignadas...</p>
      )}
    </div>
  );
};

export default ListarTarjetasAsignadas;
